import { ColumnDef } from "@tanstack/react-table";
import { DurationColumn } from "@/components/tableColumns/DurationColumn";
import { LinkColumn } from "@/components/tableColumns/LinkColumn";
import { StructureNameCell } from "@/components/tableColumns/StructureNameCell";
import { BooleanColumn } from "@/components/tableColumns/BooleanColumn";
import { EventListItem } from "@/endpoints/dryp/event";
import { DateTime } from "luxon";

export const Columns: ColumnDef<EventListItem>[] = [
	{
		id: "structureId",
		accessorKey: "structureId",
		header: "Structure ID",
	},
	LinkColumn<EventListItem>({
		accessorKey: "structureName",
		id: "structureName",
		header: "Name",
		className: "font-medium tracking-tight",
		linkText: row => <StructureNameCell name={row.structureName} isActive={row.isActive} />,
		link: row => ({
			to: "Dashboard.Structures.Structure",
			params: { id: row.structureId },
			query: {},
		}),
		tooltipText: row => `Go to ${row.structureName}`,
	}),
	{
		accessorKey: "eventType",
		id: "eventType",
		header: "Event Type",
		cell: ({ getValue }) => {
			const eventType = getValue() as EventListItem["eventType"];
			const colorMap: Record<string, string> = {
				Rain: "bg-sky-400",
				OverFlow: "bg-red-500",
				Blockage: "bg-amber-800",
			};
			return (
				<div className="flex items-center gap-2 px-2">
					<span
						className={`w-[10px] h-[10px] rounded-full inline-block shrink-0 ${colorMap[eventType.name] ?? "bg-gray-400"}`}
					/>
					<span>{eventType.name}</span>
				</div>
			);
		},
	},
	{
		id: "start",
		accessorFn: row => (row.start != null ? DateTime.fromMillis(row.start).toISO() : null),
		header: "Start",
		cell: ({ getValue }) => {
			const raw = getValue() as string | null;
			const dt = raw ? DateTime.fromISO(raw) : null;
			return <div className="p-2 text-sm">{dt?.isValid ? dt.toFormat("dd LLL yyyy, HH:mm") : "—"}</div>;
		},
	},
	{
		id: "end",
		accessorFn: row => (row.end != null ? DateTime.fromMillis(row.end).toISO() : null),
		header: "End",
		cell: ({ getValue }) => {
			const raw = getValue() as string | null;
			const dt = raw ? DateTime.fromISO(raw) : null;
			return <div className="p-2 text-sm">{dt?.isValid ? dt.toFormat("dd LLL yyyy, HH:mm") : "—"}</div>;
		},
	},
	DurationColumn<EventListItem>({
		id: "durationInSeconds",
		accessorKey: "durationInSeconds",
		header: "Duration",
		align: "left",
		durationClassName: "text-sm text-muted-foreground",
	}),
	BooleanColumn<EventListItem>({
		id: "isEventDataValidated",
		accessorKey: "isEventDataValidated",
		header: "Validated",
		align: "center",
	}),
];
